import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconBikeframe = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "m22.9 19.1-5.5-14.3c0-.1-.1-.2-.1-.2s-.1-.1-.1-.1c-.1-.2-.2-.2-.2-.2-.1 0-.1-.1-.1-.1-.1 0-.1 0-.2 0s-.1 0-.2 0h-2.2v1.1c0 .6.5 1.1 1.1 1.1h.3l.3 1h-7.4l-.7-2.3c.4-.1.8-.5.8-1-0-.6-.5-1.1-1.1-1.1h-2.2c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h.3l.9 3-5.3 10.4c-.2.4-.2.9.1 1.3s.7.6 1.1.6h8.9c.8 0 1.6-.5 2-1.2l4.2-8.3 3.4 8.9c.2.4.6.7 1 .7.1 0 .3 0 .4-.1.4-.2.7-.9.5-1.4zm-19-.7 3.5-7.1 2 7.1zm7.7-.6-2.4-8.2h6.5z" }))));
};
